module.exports = __webpack_public_path__ + "img/grey.ca5982a4.svg";